export default "__VITE_ASSET__ClBNQGyI__"